import type { BaseController } from '@infra/controllers/base.controller';
import type { SwapCallUsecase } from './swap-call.usecase';

export type SwapCallInput = void;

export type SwapCallOutput = void;

export class SwapCallController
  implements BaseController<SwapCallInput, SwapCallOutput>
{
  constructor(private usecase: SwapCallUsecase) {}

  async handle(): Promise<SwapCallOutput> {
    await this.usecase.run();
  }
}
